import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAttachment = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	fill: "none",
	viewBox: "0 0 20 20",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: 1.5,
		d: "m13.085 5.871-7.071 6.997a1.51 1.51 0 0 0 0 2.153 1.55 1.55 0 0 0 2.176 0l8.159-8.074a3.022 3.022 0 0 0 0-4.305 3.1 3.1 0 0 0-4.352 0l-7.895 7.812-.15.15a4.282 4.282 0 0 0-1.2 2.868c-.002.052-.002.105-.002.211 0 .243 0 .364.005.466.107 2.217 1.899 3.99 4.14 4.096.103.005.225.005.47.005l.214-.001a4.375 4.375 0 0 0 3.05-1.337l5.72-5.659"
	})]
});
const ForwardRef = forwardRef(SvgAttachment);
export { ForwardRef as ReactComponent };
